import MainImage from '../header/MainImage'
// import imageUrl from '../../images/main-page.jpg';
import "../../style/home.css"
import OfferBox from './Offers'
import ServiceBox from './ServiceBox'
import CleanerSlider from './CleanerSlider'
import CarpenterSlider from './CarpenterSlider'
import ElectricianSlider from './ElectricianSlider'
import ReviewSlider from './ReviewSlider'
const Home = () => {
    return(
        <>  
            <MainImage alt="home-main"/>
            <ServiceBox />
            <div className="fix-space"></div>
            <OfferBox />
            <CleanerSlider />
            <CarpenterSlider />
            <ElectricianSlider />
            <ReviewSlider />
            
        </>
        
    )
}

export default Home

